import React from "react";
import "./Careers.css";

const CareersPage = () => {
    return (

        <>


            <div className="careers-page-container">


                <div className="herosection_careers">
                    <div className="careers-container">
                        <div className="careers-hero">
                            <div className="careers-hero-content">
                                <div className="careers-hero-subtitle">Careers At AGCX</div>
                                <h1 className="careers-hero-title">
                                    Build the Future <br />
                                    of <span className="careers-solid-gold-text">Finance</span>
                                </h1>
                                <p className="careers-hero-desc">
                                    Join a global team of innovative thinkers. We raise a new<br />
                                    generation of crypto products. Grow your career and make<br />
                                    a real impact.
                                </p>
                                <a href="#jobs" className="careers-btn-primary">
                                    Explore Open Positions &nbsp;&gt;
                                </a>
                                <div className="careers-stats">
                                    <div className="careers-stat-item">
                                        <h4>50+</h4>
                                        <p>Team Members</p>
                                    </div>
                                    <div className="careers-stat-item">
                                        <h4>30+</h4>
                                        <p>Projects Done</p>
                                    </div>
                                    <div className="careers-stat-item">
                                        <h4>200+</h4>
                                        <p>Total Users</p>
                                    </div>
                                </div>
                            </div>
                            <div className="careers-hero-image">
                                <div className="careers-hero-image-wrapper">
                                    <img src="/images/careers-img/careers_bnr_img.png" alt="Build the Future of Finance" className="main-bnr-img" />


                                    <div className="floating-card floating-card-growth">
                                        <div className="fc-icon fc-icon-green">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M17 6H23V12" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div className="fc-text">
                                            <span className="fc-title">Growth</span>
                                            <span className="fc-desc">+24%</span>
                                        </div>
                                    </div>


                                    <div className="floating-card floating-card-team">
                                        <div className="fc-icon fc-icon-blue">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div className="fc-text">
                                            <span className="fc-title">Team</span>
                                            <span className="fc-desc">50+ Members</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="careers-container">

                    <div className="careers-why-build">
                        <h2 className="careers-section-title">Why Build With AGCX?</h2>
                        <div className="careers-features-grid">
                            <div className="careers-feature-card">
                                <div className="careers-feature-icon-wrapper">
                                    <img src="/images/careers-img/why_build_icon.svg" alt="Future-Proof" />
                                </div>
                                <h3 className="careers-feature-title">Future-Proof</h3>
                                <p className="careers-feature-desc">We're building solutions for long term growth.</p>
                            </div>
                            <div className="careers-feature-card">
                                <div className="careers-feature-icon-wrapper">
                                    <img src="/images/careers-img/why_build_icon2.svg" alt="Integrity" />
                                </div>
                                <h3 className="careers-feature-title">Integrity</h3>
                                <p className="careers-feature-desc">Always doing what's right for our users and partners.</p>
                            </div>
                            <div className="careers-feature-card">
                                <div className="careers-feature-icon-wrapper">
                                    <img src="/images/careers-img/why_build_icon3.svg" alt="Mission-Proof" />
                                </div>
                                <h3 className="careers-feature-title">Mission-Proof</h3>
                                <p className="careers-feature-desc">We build with purpose and client needs.</p>
                            </div>
                            <div className="careers-feature-card">
                                <div className="careers-feature-icon-wrapper">
                                    <img src="/images/careers-img/why_build_icon4.svg" alt="Global Impact" />
                                </div>
                                <h3 className="careers-feature-title">Global Impact</h3>
                                <p className="careers-feature-desc">An ecosystem built to benefit millions.</p>
                            </div>
                            <div className="careers-feature-card">
                                <div className="careers-feature-icon-wrapper">
                                    <img src="/images/careers-img/why_build_icon5.svg" alt="Work Life" />
                                </div>
                                <h3 className="careers-feature-title">Work Life</h3>
                                <p className="careers-feature-desc">We values balance to support team success.</p>
                            </div>
                        </div>
                    </div>

                    {/* --- Find Your Next Opportunity Section --- */}
                    <div id="jobs" className="careers-jobs-section">
                        <h2 className="careers-section-title">Find Your Next <span className="careers-gradient-text">Opportunity</span></h2>
                        <p className="careers-jobs-subtitle">Explore roles that match your skills. We run rigorous and fair selection processes —
                            always looking for great talent.</p>

                        <div className="careers-jobs-list">
                            <div className="careers-job-row">
                                <div className="careers-job-info-left">
                                    <div className="careers-job-icon">
                                        <img src="/images/careers-img/opportunity_icon.svg" alt="Frontend Developer" />
                                    </div>
                                    <div className="careers-job-details">
                                        <h4 className="careers-job-title">Senior Frontend Developer</h4>
                                        <div className="careers-job-meta">
                                            <span><i className="ri-time-line"></i> Full-Time</span>
                                            <span><i className="ri-earth-line"></i> Global</span>
                                        </div>
                                    </div>
                                </div>
                                <a href="#apply" className="careers-btn-outline">Apply Now</a>
                            </div>

                            <div className="careers-job-row">
                                <div className="careers-job-info-left">
                                    <div className="careers-job-icon">
                                        <img src="/images/careers-img/opportunity_icon2.svg" alt="Backend Engineer" />
                                    </div>
                                    <div className="careers-job-details">
                                        <h4 className="careers-job-title">Backend Engineer</h4>
                                        <div className="careers-job-meta">
                                            <span><i className="ri-time-line"></i> Full-Time</span>
                                            <span><i className="ri-map-pin-line"></i> Dubai</span>
                                        </div>
                                    </div>
                                </div>
                                <a href="#apply" className="careers-btn-outline">Apply Now</a>
                            </div>

                            <div className="careers-job-row">
                                <div className="careers-job-info-left">
                                    <div className="careers-job-icon">
                                        <img src="/images/careers-img/opportunity_icon3.svg" alt="Product Manager" />
                                    </div>
                                    <div className="careers-job-details">
                                        <h4 className="careers-job-title">Product Manager</h4>
                                        <div className="careers-job-meta">
                                            <span><i className="ri-time-line"></i> Full-Time</span>
                                            <span><i className="ri-map-pin-line"></i> Dubai</span>
                                        </div>
                                    </div>
                                </div>
                                <a href="#apply" className="careers-btn-outline">Apply Now</a>
                            </div>

                            <div className="careers-job-row">
                                <div className="careers-job-info-left">
                                    <div className="careers-job-icon">
                                        <img src="/images/careers-img/opportunity_icon4.svg" alt="Data Analyst" />
                                    </div>
                                    <div className="careers-job-details">
                                        <h4 className="careers-job-title">Data Analyst</h4>
                                        <div className="careers-job-meta">
                                            <span><i className="ri-time-line"></i> Full-Time</span>
                                            <span><i className="ri-earth-line"></i> Global</span>
                                        </div>
                                    </div>
                                </div>
                                <a href="#apply" className="careers-btn-outline">Apply Now</a>
                            </div>

                            <div className="careers-job-row">
                                <div className="careers-job-info-left">
                                    <div className="careers-job-icon">
                                        <img src="/images/careers-img/opportunity_icon5.svg" alt="UI/UX Designer" />
                                    </div>
                                    <div className="careers-job-details">
                                        <h4 className="careers-job-title">UI/UX Designer</h4>
                                        <div className="careers-job-meta">
                                            <span><i className="ri-file-text-line"></i> Contract</span>
                                            <span><i className="ri-map-pin-line"></i> Dubai</span>
                                        </div>
                                    </div>
                                </div>
                                <a href="#apply" className="careers-btn-outline">Apply Now</a>
                            </div>
                        </div>
                        <a href="#jobs" className="careers-btn-primary" style={{ borderRadius: "30px", padding: "12px 30px" }}>
                            View All Positions &rarr;
                        </a>
                    </div>

                    {/* --- Our Hiring Process Section --- */}
                    <div className="careers-process-section">
                        <h2 className="careers-section-title" style={{ textAlign: "center" }}>Our Hiring Process</h2>
                        <div className="careers-process-grid">
                            <div className="careers-process-card">
                                <span className="careers-process-number">01</span>
                                <div className="careers-process-icon">
                                    <img src="/images/careers-img/hiring_icon.svg" alt="Apply Online" />
                                </div>
                                <h3 className="careers-process-title">Apply Online</h3>
                                <p className="careers-process-desc">Submit your resume, portfolio and details.</p>
                            </div>
                            <div className="careers-process-card">
                                <span className="careers-process-number">02</span>
                                <div className="careers-process-icon">
                                    <img src="/images/careers-img/hiring_icon2.svg" alt="Screening Call" />
                                </div>
                                <h3 className="careers-process-title">Screening Call</h3>
                                <p className="careers-process-desc">Initial call with recruitment team.</p>
                            </div>
                            <div className="careers-process-card">
                                <span className="careers-process-number">03</span>
                                <div className="careers-process-icon">
                                    <img src="/images/careers-img/hiring_icon3.svg" alt="Interview Round" />
                                </div>
                                <h3 className="careers-process-title">Interview Round</h3>
                                <p className="careers-process-desc">Technical & cultural fit interviews.</p>
                            </div>
                            <div className="careers-process-card">
                                <span className="careers-process-number">04</span>
                                <div className="careers-process-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#D1AA67" strokeWidth="1.94805" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M22 4L12 14.01l-3-3" stroke="#D1AA67" strokeWidth="1.94805" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="careers-process-title">Offer</h3>
                                <p className="careers-process-desc">Receive and welcome dynamic package.</p>
                            </div>
                        </div>
                    </div>

                    {/* --- Social/Community Section --- */}
                    <div className="careers-social-section">
                        <h2 className="careers-section-title">
                            Explore More Media Reports &<br />
                            Build the Crypto Future with <span className="careers-gradient-text">AGCX</span>
                        </h2>
                        <p className="careers-jobs-subtitle" style={{ maxWidth: "700px", margin: "0 auto" }}>
                            Stay updated with our latest news, insights, and updates in the space. Find and follow us across our social media platforms.
                        </p>

                        <div className="careers-social-grid">
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon.png" alt="LinkedIn" /></div>
                                <h4 className="careers-social-title">LinkedIn</h4>
                                <p className="careers-social-desc">To find all professional updates & news</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon2.png" alt="Instagram" /></div>
                                <h4 className="careers-social-title">Instagram</h4>
                                <p className="careers-social-desc">To see highlights, events and culture news</p>
                            </div>
                            <div className="careers-social-card highlighted">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon3.png" alt="AGCX" /></div>
                                <h4 className="careers-social-title">AGCX</h4>
                                <p className="careers-social-desc">Join our official telegram channels/groups</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon4.png" alt="X (Twitter)" /></div>
                                <h4 className="careers-social-title">X (Twitter)</h4>
                                <p className="careers-social-desc">To see latest updates & community news</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon5.png" alt="YouTube" /></div>
                                <h4 className="careers-social-title">YouTube</h4>
                                <p className="careers-social-desc">Tutorials, interviews & video updates</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon6.png" alt="TikTok" /></div>
                                <h4 className="careers-social-title">TikTok</h4>
                                <p className="careers-social-desc">Short video news & highlight clips</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon7.png" alt="Telegram" /></div>
                                <h4 className="careers-social-title">Telegram</h4>
                                <p className="careers-social-desc">Join official telegram channels & groups</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon8.png" alt="Medium" /></div>
                                <h4 className="careers-social-title">Medium</h4>
                                <p className="careers-social-desc">Read articles & weekly reports</p>
                            </div>
                            <div className="careers-social-card">
                                <div className="careers-social-icon"><img src="/images/careers-img/media_social_icon9.png" alt="CoinMarketCap" /></div>
                                <h4 className="careers-social-title">CoinMarketCap</h4>
                                <p className="careers-social-desc">Track tokens status & statistics</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CareersPage;